<template>
   <div class="layer-checkbox">
      <div class="mb-0 w-100 d-flex" style="justify-content: space-between; align-content: flex-start;">
         <label style="width: 80%" :for="layer.id">
            <input
               class="mr-2"
               type="checkbox"
               @click="event => $emit('checkbox-toggle', {id: layer.id, visible: event.target.checked, opacity})"
               :id="layer.id"
               v-model="layer.visible"
               :disabled="disabled"
            >
            {{ languageIsEnglish ? layer.titleEnglish : layer.titleNepali }}
         </label>
         <a class="side-icons">
            <img
               class="source-info"
               src="../../assets/icons/info.svg"
               :title="description"
            >
            <img 
               src="../../assets/icons/down-arrow.svg"
               :class="{'flip-up': showLegend}"
               :title="showLegend ? 'Show less' : 'Show more'"
               @click="showLegend=!showLegend"
            >
         </a>
      </div>
      <div v-if="showLegend">
         <img class="legend" :src="layer.legendPath">
         <br class="p-0 m-0">
         <vue-slider
            v-if="opacitySlider"
            class="ml-4 mr-3"
            :min="0" :max="1" :interval="0.01"
            v-model="opacity"
            :title="`Change opacity(${opacity*100}%)`"
            @change="$emit('change-opacity', {opacity, layer:layer })"
         />
      </div>
   </div>
</template>

<script>
import { bus } from '../../main';


export default {
   props: {
      opacitySlider: { type: Boolean },
      layer: { type: Object, required: true },
      languageIsEnglish: { type: Boolean, required: true },
   },
   data()
   {
      return {
         opacity: 0.9,
         showLegend: false,
         disabled: false,
      };
   },
   created()
   {
      if (this.layer.id==="municipality")
      {
         bus.$on('enable-municipality-checkbox', () => this.disabled=false);
         bus.$on('disable-municipality-checkbox', () => this.disabled=true);
      }
   },
   computed: {
      description()
      {
         return this.languageIsEnglish ?
            `Source: ${this.layer.sourceInfo || 'N/A'}\nDescription: ${this.layer.description || 'N/A'}`
            :
            `स्रोत: ${this.layer.sourceInfoNepali || 'N/A'}\nविवरण: ${this.layer.descriptionNepali || 'N/A'}`;
      }
   }
}
</script>

<style scoped>
.layer-checkbox {
   overflow: hidden;
}
label {
   font-size: 12px;
   font-weight: 500;
   cursor: pointer;
}
input {
   cursor: pointer;
}
.side-icons {
   float: right;
}
.side-icons img {
   margin: 0 1px;
   width: 14px;
   cursor: pointer;
}
.legend {
   margin-left: 20px;
}
.flip-up {
   transform: rotate(180deg);
}
</style>